module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-04.6c30663e.jpg";